import { render } from "./Description.vue?vue&type=template&id=37da338d&scoped=true"
import script from "./Description.vue?vue&type=script&lang=js"
export * from "./Description.vue?vue&type=script&lang=js"

import "./Description.vue?vue&type=style&index=0&id=37da338d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37da338d"

export default script